export default "__VITE_ASSET__CgdeDwyJ__"